// Umami Analytics Wrapper
// Handles safe event tracking even if script hasn't loaded yet

export const trackEvent = (eventName, eventData = {}) => {
  if (window.umami && typeof window.umami.track === 'function') {
    try {
      window.umami.track(eventName, eventData);
    } catch (err) {
      // Tracking error, silently fail
    }
  }
};
